import VehicleItem from '../VehicleItem'

const DEFAULT_SKELETON_COUNT = 3

export default function VehicleItemSkeletonList({ count = DEFAULT_SKELETON_COUNT, itemKeyPrefix = 'vehicle-item-skeleton' }) {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <VehicleItem key={`${itemKeyPrefix}-${index}`} isLoading />
      ))}
    </>
  )
}
